import { render, staticRenderFns } from "./OffCanvasMenu.vue?vue&type=template&id=442c9165"
import script from "./OffCanvasMenu.vue?vue&type=script&lang=ts"
export * from "./OffCanvasMenu.vue?vue&type=script&lang=ts"
import style0 from "./OffCanvasMenu.vue?vue&type=style&index=0&id=442c9165&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports